var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3118",
  d: "M4.2 23.01V5.6A2.8 2.8 0 0 1 7 2.8h14a2.8 2.8 0 0 1 2.8 2.8v17.41c0 1.1-1.311 1.672-2.117.924L14 16.8l-7.682 7.134c-.807.748-2.118.176-2.118-.924"
})));
export default SvgChevronMobile;